<template>
  <div class="mx-auto w-[70%] border-t h-[2px]"></div>
</template>

<script>
export default {};
</script>

<style></style>
